module.exports = __webpack_public_path__ + "media/components/assets/kakaotalk_icon-98a3feb0e529ca9878828225438f1223.svg";